/**
 * Turns query string like hello=1&another=2 into object {hello: 1, another: 2}
 * @param {*} queryString
 */
function parseQuery(queryString) {
  var query = {};
  var pairs = (
    queryString[0] === "?" ? queryString.substring(1) : queryString
  ).split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
}

function modifyColor(col, amt) {
  var usePound = false;

  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (
    (usePound ? "#" : "") +
    String("000000" + (g | (b << 8) | (r << 16)).toString(16)).slice(-6)
  );
}

function addAlpha(color, opacity) {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
}

function parsePrice(price, thousandSeparator, decimalSeparator) {
  const regEx = new RegExp(
    `([0-9${thousandSeparator}]+)(\\${decimalSeparator}\\d+)?`
  );
  const [_ignored, int, decimals] = price.match(regEx);
  return parseFloat(
    `${int.replace(/[^0-9]/g, "")}.${(decimals || "0").replace(/[^0-9]/g, "")}`
  );
}

/** Helper function to save a list of string values in a state, useful for a list of checkboxes */
function handleCheckboxes(event, id, setState) {
  if (event.target.checked) {
    setState((value) => [...value, id]);
  } else {
    setState((value) => value.filter((it) => it !== id));
  }
}

/* Truncate a string after the gived nr of characters and add "..." */
function truncateText(text, length) {
  if (text.length <= length) {
    return text;
  }

  return text.substr(0, length) + "\u2026";
}

/* Helper to sort products --> supports sorting by: PRICE, TITLE */
function sortProducts(orderby, productsArray) {
  const getPrice = (price) => {
    const numericPriceString = price.replace(/[^\d.-]/g, "");
    if (numericPriceString.split("-").length > 1) {
      return parseFloat(numericPriceString.split("-")[0]);
    }
    return parseFloat(numericPriceString);
  };

  let sortedProducts = [];
  if (orderby && orderby === "title") {
    sortedProducts = [...productsArray].sort((a, b) =>
      a.name > b.name ? 1 : -1
    );
  }
  if (orderby && orderby === "price_asc") {
    sortedProducts = [...productsArray].sort((a, b) =>
      getPrice(a.price) > getPrice(b.price) ? 1 : -1
    );
  }
  if (orderby && orderby === "price_desc") {
    sortedProducts = [...productsArray].sort((a, b) =>
      getPrice(a.price) < getPrice(b.price) ? 1 : -1
    );
  }
  if (
    (orderby && orderby === "relevans") ||
    orderby === undefined ||
    orderby === ""
  ) {
    sortedProducts = [...productsArray];
  }
  return sortedProducts;
}

function checkGTM() {
  const scripts = document.head.getElementsByTagName("script");
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src.includes("www.googletagmanager.com")) {
      return true;
    }
  }
  return false;
}

function updateDataLayer(datalayerFunction) {
  const interval = setInterval(async () => {
    if (checkGTM()) {
      window.dataLayer = window.dataLayer ?? [];
      window.dataLayer.push({ ecommerce: null });
      await datalayerFunction();
      clearInterval(interval);
    }
  }, 200);
}

function formatPrice(price) {
  const formattedNumber = (number) =>
    number.toLocaleString("no-NO", {
      useGrouping: true,
      groupingSeparator: " ",
    });

  price = parseInt(price?.replace(/[^\d,-]/g, ""), 10);
  price = formattedNumber(price);
  price += ",-";

  return price;
}

module.exports = {
  parseQuery,
  addAlpha,
  modifyColor,
  parsePrice,
  handleCheckboxes,
  sortProducts,
  truncateText,
  updateDataLayer,
  formatPrice,
};
